import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const submitCheckIn = (answers) => api.post("/checkin", { answers }).then((r) => r.data);
export const getPlan = (id) => api.get(`/plans/${id}`).then((r) => r.data);
export const getEvidence = () => api.get("/evidence").then((r) => r.data);
export const getInsights = () => api.get("/insights").then((r) => r.data);
export const getInsight = (slug) => api.get(`/insights/${slug}`).then((r) => r.data);

export default api;
